import { AuthProvider } from '@agentnet/auth';
import { withFeatureFlagProvider } from '@agentnet/feature-flags';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import 'ag-grid-enterprise';
import { OrderCreateProvider } from 'hooks/OrderCreateContext';
import { OrderInfoProvider } from 'hooks/OrderInfoContext';
import { AnonymousTrackingProvider } from 'hooks/AnonymousTrackingContext';
import { ViewStateProvider } from 'hooks/ViewStateContext';
import { BrowserRouter as Router } from 'react-router-dom';
import './common-assets/styles/styles.scss';
import AppCore from './core/AppCore';
import { FileDataProvider } from './hooks/FileDataContext';
import { FincenReportProvider } from './hooks/FincenReportContext';
import { ProfileProvider } from './hooks/ProfileContext';
import { SignUpUserProvider } from './hooks/SignUpContext';
import { TelemetryProvider } from './telemetry';
import { GlobalMsgProvider } from './ui-kit/components/notification/GlobalMsgProvider';
import { SnackbarMessageProvider } from './ui-kit/components/notification/SnackbarProvider';
import { theme } from './ui-kit/theme/theme';
import { useCspViolationReporter } from 'hooks/useCspViolationReporter';

function _App(): JSX.Element {
  useCspViolationReporter();

  return (
    <Router
      getUserConfirmation={() => {
        /* Empty callback to block the default browser prompt so we can display custom modals that respond to navigation events */
      }}
    >
      <TelemetryProvider>
        <AuthProvider>
          <SignUpUserProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <SnackbarMessageProvider>
                <ProfileProvider>
                  <FileDataProvider>
                    <FincenReportProvider>
                      <GlobalMsgProvider>
                        <ViewStateProvider>
                          <AnonymousTrackingProvider>
                            <OrderInfoProvider>
                              <OrderCreateProvider>
                                <AppCore />
                              </OrderCreateProvider>
                            </OrderInfoProvider>
                          </AnonymousTrackingProvider>
                        </ViewStateProvider>
                      </GlobalMsgProvider>
                    </FincenReportProvider>
                  </FileDataProvider>
                </ProfileProvider>
              </SnackbarMessageProvider>
            </ThemeProvider>
          </SignUpUserProvider>
        </AuthProvider>
      </TelemetryProvider>
    </Router>
  );
}

const App = withFeatureFlagProvider(_App);
export default App;
